<template>
<div class="container-fluid" v-show="lists.length">
	<h4 class="text-center">{{lists.length}} gene lists</h4>
	<div class="list-group">
		<div class="list-group-item" v-for="list in lists" >
			<b>{{list.display}}</b>
			<button class="btn btn-sm btn-info float-right" @click="showGene(list)">{{list.genes.length}} genes</button>
			<table class="table table-sm mt-3" v-if="list.$show">
				<thead>
					<tr>
						<!-- <th></th> -->
						<th class="pointer" @click="sortAction(list,'gene_name')"><span class="pointer mr-2" >
							<v-icon class="align-middle" name="sort" v-if="sort.by!='gene_name'"></v-icon>
							<v-icon class="align-middle" name="sort-up" v-if="sort.by=='gene_name'&&sort.asc"></v-icon>
							<v-icon class="align-middle" name="sort-down" v-if="sort.by=='gene_name'&&!sort.asc"></v-icon>
						</span>Gene name
						</th>
						<th class="pointer" @click="sortAction(list,'prot_id')"><span class="pointer mr-2" >
							<v-icon class="align-middle" name="sort" v-if="sort.by!='prot_id'"></v-icon>
							<v-icon class="align-middle" name="sort-up" v-if="sort.by=='prot_id'&&sort.asc"></v-icon>
							<v-icon class="align-middle" name="sort-down" v-if="sort.by=='prot_id'&&!sort.asc"></v-icon>
						</span>Uniprot ID
						</th>
						<th class="pointer" @click="sortAction(list,'potential_ensembl_id')"><span class="pointer mr-2" >
							<v-icon class="align-middle" name="sort" v-if="sort.by!='potential_ensembl_id'"></v-icon>
							<v-icon class="align-middle" name="sort-up" v-if="sort.by=='potential_ensembl_id'&&sort.asc"></v-icon>
							<v-icon class="align-middle" name="sort-down" v-if="sort.by=='potential_ensembl_id'&&!sort.asc"></v-icon>
						</span>EnsemblID
						</th>

						<th class="pointer" @click="sortAction(list,'diff')"><span class="pointer mr-2">
							<v-icon class="align-middle" name="sort" v-if="sort.by!='diff'"></v-icon>
							<v-icon class="align-middle" name="sort-up" v-if="sort.by=='diff'&&sort.asc"></v-icon>
							<v-icon class="align-middle" name="sort-down" v-if="sort.by=='diff'&&!sort.asc"></v-icon>
						</span>Difference</th>
						<th class="pointer" @click="sortAction(list,'significance')"><span class="pointer mr-2" >
							<v-icon class="align-middle" name="sort" v-if="sort.by!='significance'"></v-icon>
							<v-icon class="align-middle" name="sort-up" v-if="sort.by=='significance'&&sort.asc"></v-icon>
							<v-icon class="align-middle" name="sort-down" v-if="sort.by=='significance'&&!sort.asc"></v-icon>
						</span>Significance
						</th>
						<th>Also in</th>
						<th></th>
					</tr>
				</thead>
				<tbody v-for="gene in list.genes">
					<tr class="pointer">
						<td><router-link class="navbar_link" :to="'/gene/'+gene.ensemblID">{{gene.gene_name}}</router-link></td>
						<!-- <td><span v-if="gene.nb !=1"><span class="ml-2"><v-icon class="align-middle" name="exclamation-triangle"></v-icon></span>{{gene.nb}}</span><span class="ml-2">{{gene.by_hand}}</span></td> -->
						<td><a target="_blank" :href="'https://www.uniprot.org/uniprot/'+gene.uniprot_id">{{gene.uniprot_id}}</a></td>
						<td>
							<a v-if="gene.ensemblID && gene.ensemblID.startsWith('ENSMUSG')" target="_blank" :href="'https://www.ensembl.org/Mus_musculus/Gene/Summary?db=core;g='+gene.ensemblID"> {{gene.ensemblID}}</a>
							<a v-if="gene.ensemblID && gene.ensemblID.startsWith('ENSG')" target="_blank" :href="'https://www.ensembl.org/Homo_sapiens/Gene/Summary?db=core;g='+gene.ensemblID"> {{gene.ensemblID}}</a>	
						</td>

						<td>{{gene.difference}}</td>
						<td>{{gene.significance}}</td>
						<td>{{gene.other_lists}}</td>
						<td><span class="pointer" @click="showGene(gene)"><v-icon class="align-middle" name="plus-square" v-if="!gene.$show"></v-icon><v-icon class="align-middle" name="minus-square" v-else></v-icon></span></td>
					</tr>
					<tr v-if="gene.$show">
						<td colspan="8">
							<dl class="row">
								<dt class="col-3 ddright">Ensembl id</dt>
								<dd class="col-9">
									<!-- <ul v-if="gene.ensembl_ids.length>1">
										<li v-for="ensembl_id in gene.ensembl_ids">
											<a v-if="ensembl_id && ensembl_id.startsWith('ENSMUSG')" target="_blank" :href="'https://www.ensembl.org/Mus_musculus/Gene/Summary?db=core;g='+ensembl_id"> {{gene.ensemblID}}</a>
											<a v-if="ensembl_id && ensembl_id.startsWith('ENSG')" target="_blank" :href="'https://www.ensembl.org/Homo_sapiens/Gene/Summary?db=core;g='+ensembl_id"> {{ensembl_id}}</a>
										</li>
									</ul> -->
									<span>
										<a v-if="gene.ensemblID && gene.ensemblID.startsWith('ENSMUSG')" target="_blank" :href="'https://www.ensembl.org/Mus_musculus/Gene/Summary?db=core;g='+gene.ensemblID"> {{gene.ensemblID}}</a>
										<a v-if="gene.ensemblID && gene.ensemblID.startsWith('ENSG')" target="_blank" :href="'https://www.ensembl.org/Homo_sapiens/Gene/Summary?db=core;g='+gene.ensemblID"> {{gene.ensemblID}}</a>

									</span>
								</dd>
								<dt class="col-3 ddright">Gene name</dt>
								<dd class="col-9">{{gene.gene_name}}</dd>
								<dt class="col-3 ddright">Uniprot id</dt>
								<dd class="col-9"><a target="_blank" :href="'https://www.uniprot.org/uniprot/'+gene.uniprot_id">{{gene.uniprot_id}}</a></dd>
								<!-- <dt class="col-3 ddright">Uniprot ids v1</dt>
								<dd class="col-9">{{gene.prot_ids}}</dd>
								<dt class="col-3 ddright">Uniprot ids v2</dt>
								<dd class="col-9">{{gene.prot_ids2}}</dd>
								<dt class="col-3 ddright">Uniprot ids v3</dt>
								<dd class="col-9">{{gene.prot_ids3}}</dd> -->
							</dl>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>
</template>

<script>	
import {HTTP} from '@/router/http';
import {siteTitle} from '@/app_config';
import { mapGetters } from 'vuex';
export default {
	name: 'Lists',
	components:{},
	data () {
		return {
			sort:{by:null,asc:true}
		}
	},
	computed:{
		...mapGetters({
			currentUser: 'currentUser',
			datasets:'datasets',
			lists:'lists'
		}),
	},
	methods:{
		showGene(obj){
			let _this = this;
			_this.$set(obj,'$show',!obj.$show)
		},
		sortAction(list,cas){
			let _this = this;
			if (_this.sort.by==cas){
				_this.$set(_this.sort,'asc',!_this.sort.asc)
			}
			else{
				_this.$set(_this.sort,'by',cas)				
				_this.$set(_this.sort,'asc',true)				
			}
			_this.filter(list);
		},
		filter(l){
			let _this = this;
			_.forEach(_this.lists, function(list){				
				list.genes = _.sortBy(list.genes,_this.sort.by);
				if (!_this.sort.asc) list.genes.reverse();
			})
			
		}
	},
	mounted() {
		var _this = this;
		_this.$store.dispatch('getLists').catch(err => { _this.$snotify.error("Sorry an error occured: "+err) });;
	}
}
</script>

// <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
	font-weight: normal;
}
a {
	color: #42b983;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
